import Speaker from './speaker'

export default Speaker
